import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledTabsContainerProps {
  maxwidth?: string;
}

export const StyledTabsContainer = styled(Box)<StyledTabsContainerProps>(({ theme, maxwidth }) => ({
  width: '100%',
  maxWidth: maxwidth ?? theme.breakpoints.values.xl,
  margin: '0 auto',
  height: 'auto',

  [theme.breakpoints.down('lg')]: {
    maxWidth: '90%',
  },

  [theme.breakpoints.down('md')]: {
    maxWidth: '95%',
  },

  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
  },
}));
